"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RightSplitFlyoutButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../../../theme/utils/useTheme");
var _toolbarTheme = require("../../styled/toolbarTheme");
var _ToolbarFlyoutButton = require("../ToolbarFlyoutButton/ToolbarFlyoutButton");
const StyledFlyoutButton = (0, _styled.default)(_ToolbarFlyoutButton.ToolbarFlyoutButton)`
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    
    margin-left: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _toolbarTheme.toolbarSplitButtonTheme.gap(themeMode);
}}};
    padding: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return _toolbarTheme.toolbarPaddingTheme.rightSplitButtonPadding(themeMode);
}}};

    &:focus::before {
        left: 0;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
`;
const RightSplitFlyoutButton = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  return /*#__PURE__*/_react.default.createElement(StyledFlyoutButton, (0, _extends2.default)({}, props, {
    themeMode: themeMode,
    ref: ref
  }));
});
exports.RightSplitFlyoutButton = RightSplitFlyoutButton;
RightSplitFlyoutButton.displayName = "RightSplitFlyoutButton";
//# sourceMappingURL=RightSplitFlyoutButton.js.map